import React from 'react';
import {QrScanner} from 'main/item/QrScanner';
import PropTypes from 'prop-types';
export const QrMatchCamera = ({style, handleScan})=>{
	return(
		<>
			<QrScanner style={style} handleScan={handleScan}/>
		</>
	)
}
QrMatchCamera.propTypes = {
	style: PropTypes.object,
	handleScan: PropTypes.func,
};
